export const FIELD_KEYS = {
  firstName: 'firstName',
  lastName: 'lastName',
  username: 'username',
  dateOfBirth: 'dateOfBirth',
  ssn: 'ssn',
  email: 'email',
  phone: 'phone',
  state: 'state',
  address1: 'address1',
  city: 'city',
  zip: 'zip',
  password: 'password',
  newPassword: 'newPassword',
  oldPassword: 'oldPassword',
  confirmation: 'confirmation',
  date: 'date',
  month: 'month',
  filterType: 'filterType',
  mergeTo: 'mergeTo',
  from: 'from',
  to: 'to',
  dateRangeFrom: 'dateRangeFrom',
  dateRangeTo: 'dateRangeTo',
  monthRangeFrom: 'monthRangeFrom',
  monthRangeTo: 'monthRangeTo',
  type: 'type',
  page: 'page',
  count: 'count',
  startDate: 'startDate',
  endDate: 'endDate',
  startDateFrom: 'startDateFrom',
  startDateTo: 'startDateTo',
  endDateFrom: 'endDateFrom',
  endDateTo: 'endDateTo',
  description: 'description',
  file: 'file',
  cardNumber: 'cardNumber',
  cvc: 'cvc',
  cardMonth: 'cardMonth',
  cardYear: 'cardYear',
  returnToAmend: 'returnToAmend',
  reasonForAmendment: 'reasonForAmendment',
  reconcile: 'reconcile',
  fileType: 'fileType',
  tags: 'tags',
  year: 'year',
  accountName: 'accountName',
  contactName: 'contactName',
  total: 'total',
  reference: 'reference',
  transactionType: 'transactionType',
  source: 'source',
  spouseFirstName: 'spouseFirstName',
  spouseLastName: 'spouseLastName',
  spouseDateOfBirth: 'spouseDateOfBirth',
  spouseSsn: 'spouseSsn',
  spouseEmail: 'spouseEmail',
  spousePhone: 'spousePhone',
  spouseState: 'spouseState',
  spouseAddress1: 'spouseAddress1',
  spouseCity: 'spouseCity',
  spouseZip: 'spouseZip',
  spouse: 'spouse',
  dependents: 'dependents',
  status: 'status',
  marriedFilingSeparately: 'marriedFilingSeparately',
  filingSingle: 'filingSingle',
  response: 'response',
  relationship: 'relationship',
  gender: 'gender',
  weightLbs: 'weightLbs',
  desiredWeightLbs: 'desiredWeightLbs',
  heightFt: 'heightFt',
  heightIn: 'heightIn',
  shippingAddressCountry: 'shippingAddressCountry',
  shippingAddressState: 'shippingAddressState',
  shippingAddressAddress1: 'shippingAddressAddress1',
  shippingAddressAddress2: 'shippingAddressAddress2',
  shippingAddressCity: 'shippingAddressCity',
  shippingAddressZip: 'shippingAddressZip',
};

export const STATE_MAP = {
  AL: 'Alabama',
  AK: 'Alaska',
  AS: 'American Samoa',
  AZ: 'Arizona',
  AR: 'Arkansas',
  // AA: 'Armed Forces Americas',
  // AE: 'Armed Forces Europe, Canada, Africa and Middle East',
  // AP: 'Armed Forces Pacific',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District Of Columbia',
  // FM: 'Federated States of Micronesia',
  FL: 'Florida',
  GA: 'Georgia',
  GU: 'Guam',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  MP: 'Northern Mariana Islands',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  // MH: 'Republic of Marshall Islands',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VI: 'Virgin Islands',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};

export const STATE_OPTIONS = Object.entries(STATE_MAP).map(([key, value]) => {
  return {
    title: value,
    value: key,
  };
});

export const MONTH_OPTIONS = [
  { value: '01', title: 'January' },
  { value: '02', title: 'February' },
  { value: '03', title: 'March' },
  { value: '04', title: 'April' },
  { value: '05', title: 'May' },
  { value: '06', title: 'June' },
  { value: '07', title: 'July' },
  { value: '08', title: 'August' },
  { value: '09', title: 'September' },
  { value: '10', title: 'October' },
  { value: '11', title: 'November' },
  { value: '12', title: 'December' },
];

export const DAY_OPTIONS = Array.from({ length: 31 }, (_, i) => {
  return { value: `${i + 1}`, title: `${i + 1}` };
});

export const RELATIONSHIP_OPTIONS = [
  { value: 'Son', title: 'Son' },
  { value: 'Daughter', title: 'Daughter' },
  { value: 'Stepchild', title: 'Stepchild' },
  { value: 'FosterChild', title: 'Foster Child' },
  { value: 'Brother', title: 'Brother' },
  { value: 'Sister', title: 'Sister' },
  { value: 'HalfSister', title: 'Half-sister' },
  { value: 'HalfBrother', title: 'Half-brother' },
];
